import { render } from "./Search.vue?vue&type=template&id=4fd0c5c2"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=4fd0c5c2&lang=scss"
script.render = render

export default script